export const CollectionIcon = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M20 14.6667V20H14.6667M20 9.33333V4H14.6667M9.33333 4H4V9.33333M4 14.6667V20H9.33333'
      stroke='currentColor'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <rect
      x='8.50'
      y='8.50'
      width='7'
      height='7'
      rx='1'
      stroke='currentColor'
      strokeWidth='1.25'
      fill='currentColor'
      fillOpacity='var(--nav-icon-fill-opacity, 0)'
    />
  </svg>
);
